import * as React from 'react';

interface Props {
  title?: string;
}

export default function BillingMethodPlaceholder({ title }: Props) {
  return (
    <div className="form-section-wrapper">
      { title &&
        <div className="form-section-wrapper__header">
          <h2 className="form-section-wrapper__title">
            {title}
          </h2>
        </div>
      }
      <div className="module" data-placeholder-rows>
        <ul className="actionable-rows">
          <li className="actionable-row actionable-row--placeholder">
            <div className="actionable-row__content"></div>
          </li>
        </ul>
      </div>
    </div>
  );
}



// WEBPACK FOOTER //
// /home/reverb/workspace/core.deploy.production/build/src/node_modules/@reverbdotcom/discovery-ui/src/billing/billing_method_placeholder.tsx